import { makeStyles } from '@mui/styles';

const useMenuPopUpStyles = makeStyles({
	root: {
		backgroundColor: '#0A7CC2',
		borderRadius: 4,
		bottom: 64,
		boxShadow: '0px 3px 6px #00000029',
		left: 4,
		position: 'absolute',
		zIndex: 100,
	},
	rootDisabled: {
		opacity: 0,
	},
	rootActive: {
		opacity: 1,
	},
	navigation: {
		listStyle: 'none',
		margin: 0,
		padding: '6px 0',
	},
	navigationItem: {
		'& > a': {
			color: '#E0E6E9',
			cursor: 'pointer',
			display: 'block',
			fontSize: 12,
			padding: '6px 12px',
			textDecoration: 'none',
		},
	},
});

export default useMenuPopUpStyles;
